import { call, takeLatest } from 'redux-saga/effects';
import { fetchExternalRedInvoiceApi } from 'utils/apollo';
import ActionTypes from '../constants';
import { message } from 'antd';
import translations from 'translations';
import messages from '../messages';

function* handleFetchExternalInvoice(action: any) {
  const { payload, meta } = action;
  try {
    const response = yield call(fetchExternalRedInvoiceApi, { taxCode: payload });

    if (response && !response.errors && !response.error) {
      meta?.(response?.data);
      return;
    }
    meta?.(null);
    message.warning(translations(messages.fetchInvoiceFail));
  } catch (_error) {
    meta?.(null);
    message.warning(translations(messages.fetchInvoiceFail));
  }
}

export default function* redInvoiceSaga() {
  yield takeLatest(ActionTypes.FETCH_EXTERNAL_INVOICE, handleFetchExternalInvoice);
}
